<template >
     <div class="literature-list">
        <div class="literature-list-head">相关文献</div>
        <div class="literature-tabs">
            <span
                v-for="tab in literatureTabs"
                :key="tab.type"
                class="literature-tab"
                :class="{ active: activeLiteratureTab === tab.type }"
                @click="activeLiteratureTab = tab.type"
            >
                {{ tab.label }} ({{ tab.count }})
            </span>
        </div>
        <div class="literature-items">

            <div
                v-for="(item, index) in filteredLiteratureList"
                :key="index"
                class="literature-item"
            >
                <div class="literature-item-title">
                    {{ index + 1 }}.{{ item.typeLabel }}{{ item.title }}
                </div>
                <div class="literature-item-meta">
                    {{ item.author }} - {{ item.institution }} - {{ item.year }}
                </div>
                <div class="literature-item-abstract">
                    <span class="label">摘要：</span>{{ item.abstract }}
                </div>
                <div class="literature-item-keywords">
                    <span class="label">关键词：</span>
                    <span
                        v-for="(kw, ki) in item.keywords"
                        :key="`${index}-${ki}`"
                        class="keyword-inline"
                    >
                        <span class="keyword" :class="{ 'is-first': ki === 0 }">{{ kw }}</span><span v-if="ki < item.keywords.length - 1" class="keyword-sep">；</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { literatureTabs, literatureList } from '../literatureListData';

export default {
    data() {
        return {
            literatureTabs,
            literatureList,
            activeLiteratureTab: 'conference',
        }
    },
    computed: {
        filteredLiteratureList() {
            return this.literatureList.filter((item) => item.type === this.activeLiteratureTab);
        },
    },
}
</script>
<style lang="less" scoped>
.literature-list {
    margin-top: 24px;
    background: #fff;
    // border: 1px solid #e4e7ed;
    padding: 20px 24px;
    box-sizing: border-box;
    .literature-list-head {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
        border-bottom: 2px solid #396de7;
        padding-bottom: 6px;
    }
}

.literature-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
}

.literature-tab {
    display: inline-block;
    padding: 6px 18px;
    font-size: 14px;
    color: #333;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 20px;
    cursor: pointer;
    user-select: none;
    transition: all 0.2s ease;

    &:hover {
        border-color: #396de7;
        color: #396de7;
    }

    &.active {
        background: #396de7;
        border-color: #396de7;
        color: #fff;
    }
}

.literature-items {
    .literature-item {
        padding: 16px 0;
        border-bottom: 1px solid #ebeef5;

        &:last-child {
            border-bottom: none;
            padding-bottom: 0;
        }

        &:first-child {
            padding-top: 0;
        }
    }
}

.literature-item-title {
    font-size: 16px;
    font-weight: bold;
    color: #396de7;
    line-height: 1.6;
    margin-bottom: 8px;
}

.literature-item-meta {
    font-size: 14px;
    color: #909399;
    line-height: 1.5;
    margin-bottom: 10px;
}

.literature-item-abstract,
.literature-item-keywords {
    font-size: 14px;
    color: #606266;
    line-height: 1.8;

    .label {
        color: #909399;
    }
}

.literature-item-abstract {
    margin-bottom: 8px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    overflow: hidden;
}

.literature-item-keywords {
    .keyword-inline {
        display: inline;
    }

    .keyword {
        color: #396de7;

        &.is-first {
            color: #e6a23c;
        }
    }

    .keyword-sep {
        color: #396de7;
    }
}    
</style>